(() => {
  const theme = window.DrivenaroTheme || {};
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: theme.currency || 'EUR'
      }).format((Number(cents) || 0) / 100);
    } catch (_) { return `${((Number(cents) || 0) / 100).toFixed(2)} ${theme.currency || ''}`; }
  };
  const esc = (value='') => String(value).replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));

  const backdrop = document.querySelector('[data-drawer-backdrop]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerItems = document.querySelector('[data-drawer-items]');
  const drawerSubtotal = document.querySelector('[data-drawer-subtotal]');
  const drawerCount = document.querySelector('[data-drawer-count]');
  const headerCount = document.querySelector('[data-cart-count]');
  const shippingBars = document.querySelectorAll('[data-shipping-bar]');
  const shippingTexts = document.querySelectorAll('[data-shipping-text]');

  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open'); backdrop?.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false'); document.body.classList.add('no-scroll');
    drawer.querySelector('[data-drawer-close]')?.focus();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open'); backdrop?.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true'); document.body.classList.remove('no-scroll');
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart(true); }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-drawer-backdrop]')) closeDrawer();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  const updateShipping = (total) => {
    const threshold = Number(theme.freeShippingThreshold || 0);
    const pct = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 0;
    shippingBars.forEach(el => el.style.width = `${pct}%`);
    shippingTexts.forEach(el => {
      if (!threshold) { el.textContent = ''; return; }
      el.textContent = total >= threshold
        ? 'You qualify for free shipping.'
        : `${money(threshold - total)} away from free shipping.`;
    });
  };

  const renderDrawer = (cart) => {
    if (headerCount) { headerCount.textContent = cart.item_count; headerCount.hidden = cart.item_count === 0; }
    if (drawerCount) drawerCount.textContent = cart.item_count;
    if (drawerSubtotal) drawerSubtotal.textContent = money(cart.total_price);
    updateShipping(cart.total_price);
    if (!drawerItems) return;
    if (!cart.items.length) {
      drawerItems.innerHTML = `<div class="drawer-empty"><p>${esc(theme.strings?.empty || 'Your cart is empty.')}</p><a class="button button--secondary" href="/collections/all">Continue shopping</a></div>`;
      return;
    }
    drawerItems.innerHTML = cart.items.map((item, index) => {
      const image = item.image ? `<img src="${esc(item.image)}&width=160" alt="${esc(item.product_title)}" width="76" height="76" loading="lazy">` : '<div class="placeholder-media"></div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="drawer-item__variant">${esc(item.variant_title)}</div>` : '';
      return `<div class="drawer-item">
        <a href="${esc(item.url)}">${image}</a>
        <div>
          <a class="drawer-item__title" href="${esc(item.url)}">${esc(item.product_title)}</a>${variant}
          <div class="drawer-item__controls"><span>Qty ${item.quantity}</span><button type="button" data-cart-remove data-line="${index + 1}">Remove</button></div>
        </div>
        <strong>${money(item.final_line_price)}</strong>
      </div>`;
    }).join('');
  };

  async function refreshCart(open = false) {
    try {
      const res = await fetch(theme.routes?.cartJson || '/cart.js', {headers:{Accept:'application/json'}});
      if (!res.ok) throw new Error('Cart request failed');
      const cart = await res.json(); renderDrawer(cart); if (open) openDrawer(); return cart;
    } catch (err) { console.error(err); }
  }

  document.addEventListener('click', async (e) => {
    const remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    remove.disabled = true;
    try {
      await fetch(theme.routes?.cartChange || '/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({line:Number(remove.dataset.line),quantity:0})
      });
      await refreshCart(false);
    } catch(err) { console.error(err); remove.disabled = false; }
  });

  document.querySelectorAll('form[data-ajax-add]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const old = button?.textContent;
      if (button) { button.disabled = true; button.textContent = 'Adding…'; }
      try {
        const res = await fetch(theme.routes?.cartAdd || '/cart/add.js', {
          method:'POST', headers:{Accept:'application/json'}, body:new FormData(form)
        });
        if (!res.ok) { const data = await res.json().catch(()=>({})); throw new Error(data.description || theme.strings?.error || 'Could not add to cart.'); }
        await refreshCart(true);
      } catch(err) { alert(err.message); }
      finally { if (button) { button.disabled = false; button.textContent = old; } }
    });
  });

  document.addEventListener('click', e => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const wrap = step.closest('[data-quantity]'); const input = wrap?.querySelector('input[type="number"]'); if (!input) return;
    const delta = Number(step.dataset.qtyStep || 0); const min = Number(input.min || 1); const max = Number(input.max || 999);
    input.value = Math.min(max, Math.max(min, Number(input.value || min) + delta)); input.dispatchEvent(new Event('change',{bubbles:true}));
  });

  document.querySelectorAll('[data-product-root]').forEach(root => {
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const button = root.querySelector('[data-product-submit]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const stickyButton = document.querySelector('[data-sticky-submit]');
    let variants = [];
    try { variants = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '[]'); } catch (_) {}
    const update = () => {
      if (!select) return;
      const variant = variants.find(v => String(v.id) === String(select.value)); if (!variant) return;
      if (price) price.textContent = money(variant.price);
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (compare) { compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : ''; compare.hidden = !(variant.compare_at_price > variant.price); }
      if (button) { button.disabled = !variant.available; button.textContent = variant.available ? (button.dataset.availableText || 'Add to cart') : (button.dataset.soldText || 'Sold out'); }
      const url = new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url);
    };
    select?.addEventListener('change', update); update();
    stickyButton?.addEventListener('click', () => { if (button && !button.disabled) button.click(); });
  });

  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  mobileToggle?.addEventListener('click', () => {
    const open = mobileMenu?.classList.toggle('is-open');
    mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.querySelectorAll('[data-sort-select]').forEach(select => select.addEventListener('change', () => select.form?.submit()));

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), {threshold:.08});
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));
  } else document.querySelectorAll('.reveal').forEach(el => el.classList.add('is-visible'));

  refreshCart(false);
})();

/* v1.3.4 product media viewer */
document.querySelectorAll('[data-product-media-viewer]').forEach((viewer) => {
  const thumbs = Array.from(viewer.querySelectorAll('[data-media-thumb]'));
  const panels = Array.from(viewer.querySelectorAll('[data-media-panel]'));
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
    const index = thumb.dataset.mediaThumb;
    thumbs.forEach((item) => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    panels.forEach((panel) => {
      const active = panel.dataset.mediaPanel === index;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
  }));
});
